// extracted by mini-css-extract-plugin
module.exports = {"loader-container":"_1rO7hOwTf3GeD1o0lxR-_V","loaderContainer":"_1rO7hOwTf3GeD1o0lxR-_V","loader-ring":"_1qffOefe3BXOOnLPfc3M2E","loaderRing":"_1qffOefe3BXOOnLPfc3M2E"};